<template>
  <vs-popup class="signature-popup" :title="(popupConfig.title) ? popupConfig.title : 'Signature'" :active.sync="popupConfig.isOpen">
    <div v-html="liability_policy"></div>
    <div class="vx-row h-full px-6 customer-signature-content">
      <img :src="popupConfig.attachment" width="50%" height="50%" style="margin: 0 auto;"/>
      <!-- <img style="margin: 0 auto;" src="https://s3-gci.nyc3.digitaloceanspaces.com/customer-checkin/1591850677_develop_9792172012_signature.png" width="50%" height="50%" /> -->
    </div>
  </vs-popup>
</template>

<script>
export default {
  name: "signature-popup",
  props: {
    popupConfig: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      liability_policy: "",
      other_policy: ""
    };
  },
  watch: {
    popupConfig: {
      immediate: true,
      deep: true,
      handler() {
        if(this.popupConfig.isOpen) {
          document.body.classList.add('overflow-hidden');
        } else {
          document.body.classList.remove('overflow-hidden');
        }
      }
    }
  },
  created() {
    this.$store.dispatch("appSetting/GET_POLICIES").then(() => {
      let policy = {};
      policy = this.$store.getters["appSetting/policyData"];
      // if (policy) {
      //   this.liability_policy = policy.liability_policy.body;
      //   this.other_policy = policy.other_policy;
      // }
      this.liability_policy = '';
      this.other_policy = '';
      if(policy && policy.length > 0) {
        for(let i = 0; i < policy.length; i++) {
          if(policy[i].slug == 'liability-policies') {
            this.liability_policy = policy[i].body;
          } else if(policy[i].slug == 'other-policies') {
            this.other_policy = policy[i].body;
          }
        }
      }
    });
  }
};
</script>